import {
  RESET_COMMENTS_FEEDS_TWEETS_AND_HEADLINES_SUCCESS,
} from './constants';

export function resetCommentsFeedsTweetsAndHeadlines() {
  return dispatch => {
    dispatch({
      type: RESET_COMMENTS_FEEDS_TWEETS_AND_HEADLINES_SUCCESS,
    });
  };
}

export function reducer(state, action) {
  if (action.type === RESET_COMMENTS_FEEDS_TWEETS_AND_HEADLINES_SUCCESS) {
    return {
      ...state,
      allComments:         { data: [], count: null },
      allTweets:           { data: [], count: null },
      allHeadlines:        { data: [], count: null },
      allFeeds:            { data: [], count: null },
      allUploadedComments: { data: [], count: null }
    };
  }
  else {
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/resetCommentsFeedsTweetsAndHeadlines.js